export default "__VITE_ASSET__Cd2SNzDW__ 584w";